"use strict";
/* globals module */
/**
 * @module meteringSettingsClient
 * @description  Metering Settings Client provides an easy way to consume  Metering REST API end-points. In order to obtain a needed routes `meteringSettingsClient` uses `meteringSettingsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var MeteringSettingsClient = /** @class */ (function () {
    function MeteringSettingsClient(meteringSettingsRoute, apiClient) {
        this.meteringSettingsRoute = meteringSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MeteringSettingsClient.prototype, "routeDefinition", {
        get: function () {
            return this.meteringSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the metering resource.
     * @method
     * @example meteringSettingsClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                      function (response, status, headers, config) {
                          // perform error handling here
                    });
     **/
    MeteringSettingsClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update metering action has been performed; this action updates a metering resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `meteringSettingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(meteringSettings);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An meteringSetting object used to update specified MeteringSetting resource.
     * @returns A promise that is resolved once the update metering action has been performed.
     * @example // meteringSettings is a resource previously fetched using get action.
                    meteringSettings.dataRetentionPeriod = 60;
                    meteringSettingsClient.update(meteringSettings)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MeteringSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    MeteringSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MeteringSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MeteringSettingsRoute !== "undefined" && _1.MeteringSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MeteringSettingsClient);
    return MeteringSettingsClient;
}());
exports.MeteringSettingsClient = MeteringSettingsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
